import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig, refineHeader } from "../../config";
import auth from "../auth";

export const reviewService = {
  add_review,
  get_review_list,
  update_review,
  get_review_details,
  get_review_list_for_admin,
  delete_review,
  change_review_status,
  update_review_by_admin,
  get_review_details_for_admin
};

function add_review(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}offer-review/add`, requestOptions)
    .then(handleResponse)
    .then(responseData => {
      return responseData;
    });
}

function update_review(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}offer-review/edit-by-user`, requestOptions)
    .then(handleResponse)
    .then(responseData => {
      return responseData;
    });
}

function get_review_list(dealID) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*"
    },
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify({ dealID: dealID })
  };

  return fetch(`${appConfig.api.url}offer-review/reviews`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_review_details() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}offer-review/detail`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//start admin apis
function get_review_list_for_admin(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}offer-review/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function change_review_status(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}offer-review/change-status`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delete_review(reviewID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}offer-review/delete/${reviewID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_review_by_admin(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}offer-review/edit`, requestOptions)
    .then(handleResponse)
    .then(responseData => {
      return responseData;
    });
}

function get_review_details_for_admin(reviewID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}offer-review/detail/${reviewID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(responseData => {
      return responseData;
    });
}

//end admin apis

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/reviewService.js